import { useState, useMemo, useEffect } from 'react';

import { getDatasetStatusRollup } from '../../../api/dataReporting';
import { preprocessSyntheticData } from '../../../utils/dataStatusReporting';
import { extractAndDeduplicateDates } from '../../../utils/dateFormatters';

export const useDataStatus = (featuredSegment, dataStatusPlatforms, selectedMetric, id, startDate, endDate, jwt, account) => {
  const [spendStatusRollup, setSpendStatusRollup] = useState([]);
  const [conversionStatusRollup, setConversionStatusRollup] = useState([]);
  const [syntheticStatusRollup, setSyntheticStatusRollup] = useState([]);

  const failureDates = useMemo(() => {
    const spendDates = extractAndDeduplicateDates(spendStatusRollup);
    const conversionDates = extractAndDeduplicateDates(conversionStatusRollup);
    const syntheticDates = extractAndDeduplicateDates(syntheticStatusRollup);

    switch (selectedMetric) {
      case 'spend':
        return new Set(spendDates);
      case 'conversions':
      case 'revenue':
      case 'rpc':
        return new Set([...syntheticDates, ...conversionDates]);
      default:
        return new Set([...spendDates, ...conversionDates, ...syntheticDates]);
    }
  }, [spendStatusRollup, conversionStatusRollup, syntheticStatusRollup, selectedMetric]);

  useEffect(() => {
    if (!featuredSegment || !dataStatusPlatforms || !account || !jwt) return;
    const useCubeData = !account?.features?.includes('data_reporting_api');
    // only use conversion data status if featured conversion segment is selected
    const conversionsStatusPromise = featuredSegment === id ? null : getDatasetStatusRollup('conversions', startDate, endDate, featuredSegment, useCubeData, jwt);
    const fetchData = async () => {
      try {
        const [spendResponse, syntheticResponse, conversionResponse] = await Promise.all([
          getDatasetStatusRollup('spend', startDate, endDate, false, useCubeData, jwt),
          getDatasetStatusRollup('synthetic_events', startDate, endDate, false, useCubeData, jwt),
          conversionsStatusPromise,
        ]);
        const filteredSpend = {
          ...spendResponse.response,
          failures: spendResponse.response.failures.filter(failure => dataStatusPlatforms.includes(failure.platform)),
        };
        setSpendStatusRollup(filteredSpend);
        setConversionStatusRollup(conversionResponse?.response);
        const filteredSynthetic = preprocessSyntheticData(syntheticResponse.response);
        setSyntheticStatusRollup(filteredSynthetic);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      }
    };
    fetchData();
  }, [startDate, endDate, featuredSegment, dataStatusPlatforms, account, jwt]);

  return {
    failureDates,
  };
};
